import type { ReactNode } from "react"

import { cn } from "@productlane/lib/src/browser"

// Animates a portal group card open and shut. The 0fr/1fr grid row gives a
// height transition without measuring; the content keeps its height and only
// fades and settles, so it never squashes mid-flight.
export function PortalGroupCollapse({
	collapsed,
	children,
	className,
}: {
	collapsed: boolean
	children: ReactNode
	className?: string
}) {
	return (
		<div
			className={cn(
				"grid transition-[grid-template-rows] duration-[260ms] ease-[cubic-bezier(0.23,1,0.32,1)] motion-reduce:transition-none",
				collapsed ? "grid-rows-[0fr]" : "grid-rows-[1fr]",
			)}
			inert={collapsed}
			aria-hidden={collapsed}
		>
			{/* The slack lets the panel's ring and shadow show past the clip. */}
			<div className="-mx-1 -my-1 min-h-0 overflow-hidden p-1">
				<div
					className={cn(
						"transition-[opacity,transform] ease-[cubic-bezier(0.23,1,0.32,1)] motion-reduce:transform-none",
						collapsed
							? "-translate-y-1 scale-[0.99] opacity-0 duration-150"
							: "translate-y-0 scale-100 opacity-100 duration-[260ms]",
						className,
					)}
				>
					{children}
				</div>
			</div>
		</div>
	)
}
